export default function workhours(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                workhour: action.workhour,
            }
        default:
            return state;
    }
}
